/*
    Copyright 2020 Lauren Gyldenlove.
    This file is part of Duelmaster.

    Duelmaster is free software: you can redistribute it and/or modify
    it under the terms of the GNU General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    Duelmaster is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU General Public License for more details.

    You should have received a copy of the GNU General Public License
    along with Foobar.  If not, see <https://www.gnu.org/licenses/>.
 */


export enum Position {
    LEFT,
    RIGHT
}

export interface Model {
    name: string
    position: Position,
    isFirst: boolean,
    wins: number
}

export type PositionType = typeof Position;

export function create(name: string, position: Position): Model {
    return {
        "name": name,
        "position": position,
        "isFirst": false,
        "wins": 0
    }
}

export function setFirst(player: Model, isFirst: boolean): Model {
    return {
        "name": player.name,
        "position": player.position,
        "isFirst": isFirst,
        "wins": player.wins
    }
}

export function setWin(player: Model, wins: number): Model {
    return {
        "name": player.name,
        "position": player.position,
        "isFirst": player.isFirst,
        "wins": wins
    }
}

export function addWin(player: Model): Model {
    return setWin(player, player.wins + 1);
}
